import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../utils/with-router-props'
import { Link } from 'react-router-dom'

import { fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'
import { PaginationWrapper } from 'shs-pagination'
import { createSelector } from '@reduxjs/toolkit'
import { startCase } from 'lodash'
import moment from 'moment'

const selectQuestions = state => state.adminQuestions
const selectQuestionPaginator = state => state.paginator.adminQuestions

const makeQuestions = createSelector(
    [selectQuestions, selectQuestionPaginator],
    (questions, paginator) => {
        if (paginator) {
            return questions
                .filter(field => paginator.itemIds.indexOf(field.id) !== -1)
                .sort((a, b) => {
                    if (paginator.itemIds.indexOf(a.id) > paginator.itemIds.indexOf(b.id)) {
                        return 1
                    }
                    return -1
                })
        }
        return []
    }
)

const mapStateToProps = (state, ownProps) => {
    const paginator = selectQuestionPaginator(state)
    const questions = makeQuestions(state)
    return {
        paginator,
        questions
    }
}

const AdminQuestionList = ({ dispatch, navigate, params, paginator, questions }) => {
    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/questions', 'LIST')))
    }, [dispatch])

    const renderQuestionRow = (question, index) => {
        return (
            <tr key={question?.id}>
                <td className="index">{index}</td>
                <td className="main">{question.label}</td>
                <td className="main">{startCase(question?._computed?.typeValue?.toLowerCase())}</td>
                <td className="main">{question.groupsCount ? question.groupsCount : 0}</td>
                <td className="main">{question.templatesCount ? question.templatesCount : 0}</td>
                <td className="main">{question.updatedAt ? moment(question.updatedAt).fromNow() : 'N/A'}</td>
                <td className="main">
                    <Link className="btn outline small" to={buildRoutePath(routes.adminQuestionEdit.path, { questionId: question.id })}>
                        Edit
                    </Link></td>
            </tr>
        )
    }

    const handlePaginationUpdate = (paginationParams) => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/questions', 'LIST'), paginationParams))
    }

    const renderQuestions = () => {
        if (!paginator) {
            return null
        }
        let allQuestions = []
        questions?.forEach((question, idx) => {
            let index = idx + ((paginator.currentPage - 1) * paginator.perPage) + 1
            allQuestions.push(renderQuestionRow(question, index))
        })
        return (
            <PaginationWrapper
                paginator={paginator}
                controls={{ search: { enabled: true, collapsed: false } }}
                callbackFX={handlePaginationUpdate}
                renderItems={allQuestions}
            >
                <table className="table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Label</th>
                            <th>Type</th>
                            <th>Groups</th>
                            <th>Templates</th>
                            <th>Updated</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allQuestions}
                    </tbody>
                </table>
            </PaginationWrapper>
        )
    }

    if (!questions) {
        return <div>Loading...</div>
    }

    return (
        <div className="admin-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>All Questions</h1>
                    </div>
                    <div className="header-actions">
                        <Link className="btn blue" to={buildRoutePath(routes.adminQuestionCreate.path)}>
                            Create New Question
                        </Link>
                    </div>
                </div>
            </div>
            <div className="bg-dark content-wrapper">
                <div className="container">
                    {renderQuestions()}
                </div>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(AdminQuestionList))
